import { create } from 'zustand';
import { Device } from '../data/Device';

type DeviceDrawerStore = {
    isOpen: boolean,
    isForward: boolean,
    level: number,
    isEdit: boolean,
    data: Device | undefined,
    setLevel: (level: number) => void,
    next: () => void,
    previous: () => void,
    openNew: () => void,
    openEdit: (data: Device) => void,
    close: () => void,
}

export const useDeviceDrawerStore = create<DeviceDrawerStore>((set) => ({
    isOpen: false,
    isForward: true,
    level: 1,
    isEdit: false,
    data: undefined,
    setLevel: (level: number) => set((state) => ({ level, isForward: state.level < level })),
    next: () => set((state) => ({ level: state.level + 1, isForward: true })),
    previous: () => set((state) => ({ level: state.level - 1, isForward: false })),
    openNew: () => set(() => ({ isOpen: true, isEdit: false, data: undefined })),
    openEdit: (data: Device) => set(() => ({ isOpen: true, isEdit: true, data: data })),
    close: () => {
        set(() => ({ isOpen: false, data: undefined }));
        setTimeout(() => set(() => ({ level: 1 })), 100);
    },
}))